import { FETCH_REVIEWS } from "./reviewTypes";

const INITIAL_STATE = {
  pubs : [],
  stadiums: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_REVIEWS:
      return { ...state, [action.payload.type]: action.payload.data };
    default:
      return state;
  }
};